import type {FC} from 'react'

/**
 * Blank, public landing page for the Birdie screen recorder.
 *
 * Birdie's recorder hands control back to the app at
 * `https://app.montblanc.ai/recorder?birdie-recording=…&birdie-embed=1`. Per
 * Birdie's docs the recording page must be blank, public (no auth, "like the
 * login page"), non-redirecting, and must preserve the query params so the
 * injected snippet (mounted by `BirdieInitializer` near the top of the router)
 * can pick the recording back up.
 *
 * This component therefore renders nothing meaningful and deliberately does NOT:
 *   - require authentication,
 *   - navigate/redirect anywhere, or
 *   - read or clear the `birdie-recording` / `birdie-embed` query params.
 */
const BirdieRecorderPage: FC = (): JSX.Element => <div data-testid="birdie-recorder-page" />

export default BirdieRecorderPage
